import { languageES } from "./lang/lang.es";
import config from "./configs/configs";
import json from "./ui/styles.json";

export default { 
  configs: config,
  json: json as any,
  lang: languageES,
  theme: THEME
}